import React, { useState, useEffect, Suspense, lazy } from "react";
import { Link } from "react-router-dom";
import { axiosReq } from "../../commons/axiosReq";
import PicNewses from "../../components/NewUIComponents/PicNewses";
import ImportantNewsBox from "../../components/NewUIComponents/ImportantNewsBox";
// import MarketLookItems from "../../components/NewUIComponents/MarketLookItems";
import MainAdvertising from "../../components/NewUIComponents/MainAdvertising";
import Ad4 from "../../assets/img/NewsImgs/motalee.jpg";
import { useOutletContext } from "react-router-dom";
import Cookies from 'universal-cookie';

const MainNewsSecond = lazy(() => import('../../components/NewUIComponents/MainNewsSecond'));
const MostVisitedNewses = lazy(() => import('../../components/NewUIComponents/MostVisitedNewse'));
const MarketLookItems = lazy(() => import('../../components/NewUIComponents/MarketLookItems'));
const GroupNewsesLeft = lazy(() => import("../../components/NewUIComponents/GroupNewsesLeft"));
const GroupNewsesRightAgriculture = lazy(() => import("../../components/NewUIComponents/GroupNewsesRightAgriculture"));

const HomePage = () => {
  const [data, setData] = useState(null);
  const [indexes, setIndexes] = useState(null);
  // const [ data, setData] = useOutletContext();
  const cookies = new Cookies();

  window.addEventListener('load', async () => {
    console.log('mofid 1');
    console.log(cookies.get('viewCounted'));

    // Check if the view has already been counted today using a cookie
    if (await cookies.get('viewCounted') != true) {
      console.log('mofid 2');
      // Call the API to increment the view count
      const dataUser = await axiosReq("Admins/increment", "get")
      console.log(333333)
      console.log(dataUser)

      if (dataUser == true) {
        console.log(5555)

        // Set a cookie to indicate the view has been counted (expires in 24 hours)
        const date = new Date();
        date.setTime(date.getTime() + (24 * 60 * 60 * 1000)); // 24 hours
        await cookies.set('viewCounted', 'true', { path: '/', expires: date });
      }
    }
  });

  useEffect(() => {
    const GetData = async () => {
      const mainData = await axiosReq("Admins/HomePage2", "get");
      setData(mainData);
      if (mainData) {
        const mainIndex = await axiosReq("Admins/GetIndex", "get");
        setIndexes(mainIndex);

      }
    };
    GetData();
  }, []);

  //   if (!data ) {
  //     return <div></div>;
  //   }

  return (
    <>
      <div className="w-full h-[250px] lg:h-[270px] h800:mb-40 h800:md:mb-14 md:pb-4 bg-mainColor2 lg:h800:h-[285px] lg:h800:md:h-auto">
        {
          data?.main ?
            <PicNewses data={data?.main} rateData={indexes?.slice(0, 6)} />
            :
            <div></div>
        }
      </div>
      <div id="margint300">
        {
          data?.important ?
            <ImportantNewsBox data={data?.important?.slice(0, 9)} boxTitle="مهم ترین اخبار روز" marginTop="300" />
            : <div></div>
        }
      </div>
      <div className="w-full bg-mainColor2 h-[160px] -mt-[100px]"></div>
      <div className="my-[80px] mx-[120px] xl:mx-[10px] lg:mt-[25px]">
        <div className="flex mt-5 lg:block">
          <div className="w-[47%] e1440:w-[47%] e1440:lg:w-full">
            <div className="flex w-[100%] justify-start items-center lg:justify-between mb-6">
              <div className="ml-5">
                <p className="text-[20px] text-nowrap font-IRANYekanExtra xl:text-[16px]">آخرین اخبار</p>
              </div>
              <div className="w-full border-b-[2px] lg:w-[50%] sm25"></div>
              <div className="mr-5 text-nowrap">
                <Link to={"archive/all"} className="text-[20px] font-IRANYekanExtra xl:text-[16px]">مشاهده همه</Link>
              </div>
            </div>
            <Suspense fallback={<div>Loading...</div>}>
              <MainNewsSecond data={data?.last} />
            </Suspense>
          </div>
          <div className="w-[25%] mr-[1%] h-[810px] lg:w-full lg:mr-0">
            <Suspense fallback={<div>Loading...</div>}>
              <MostVisitedNewses data={data?.mostViewed} />
            </Suspense>
          </div>
          <div className="w-[32%] mr-[1%] h-[850px] e1440:w-[32%] lg:h-auto lg:mr-0 e1440:lg:w-full lg:mt-10">
            <div className="h-[280px] 2xl:h-[355px] 2xl:lg:h-auto">
              <Suspense fallback={<div>Loading...</div>}>

                <MarketLookItems data={indexes?.slice(6, 16)} />
              </Suspense>

            </div>
            <div className="my-[10px]">
              <img src={Ad4} loading="lazy" className="h-[500px] w-full object-fill rounded-[10px] shadow-main-shadow" />
            </div>
          </div>
        </div>
      </div>
      {data && Object.keys(data)?.map((key, index) => {
        if (key !== "main" && key !== "last" && key !== "mostViewed" && key !== "important") {
          return index % 2 === 0 ? (
            <div key={key} className="my-[50px]">
              <Suspense fallback={<div>Loading...</div>}>
                <GroupNewsesLeft data={data[key]}>{key}</GroupNewsesLeft>
              </Suspense>
            </div>
          ) : (
            <div key={key}>
              <Suspense fallback={<div>Loading...</div>}>
                <GroupNewsesRightAgriculture data={data[key]}>{key}</GroupNewsesRightAgriculture>
              </Suspense>
            </div>
          );
        }
        return null;
      })}
    </>
  );
};

export default HomePage;